export default "__VITE_ASSET__H2erOx7y__"